export default __webpack_public_path__ + "static/media/img-influencer-01.e8f12d9e.png";